<a mat-list-item (click)="toggle()" style="width: fit-content;">
        <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
            class="submenu">
            <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Tabelas de Referência">
                <mat-icon>table_chart</mat-icon>
                <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Tabelas de Referência</span>
            </div>
            <div fxLayout="row" fxLayoutAlign="start stretch">
                <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
            </div>
        </div>
    </a>
    
    <mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">
    
        <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">
    
            <!-- CONDICOES MORADIA -->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().CONDICOES_MORADIA)" icone="museum" titulo="Condição de Moradia" rota="condicaomoradia" toolTip="Condição de Moradia"></sub-menu>
            </div>

            <!-- SITUACAO VULNERABILIDADE-->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().SITUACAO_VULNERABILIDADE)" icone="sentiment_dissatisfied" titulo="Situação de Vulnerabilidade" rota="situacaovulnerabilidade" toolTip="Situação de Vulnerabilidade"></sub-menu>
            </div>

            <!-- SOLUÇOES ATENDIMENTO -->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().SOLUCAO_ATENDIMENTO)" icone="insert_invitation" titulo="Soluções de Atendimentos" rota="solucaoatendimento" toolTip="Soluções de Atendimentos"></sub-menu>
            </div>            
    
            <!-- DIAGNOSTICO ATENDIMENTO -->
            <div style="padding-left: 15px">
                <sub-menu *ngIf="verificaAcesso(getModulos().DIAGNOSTICO_ATENDIMENTO)" icone="ballot" titulo="Tipos de Diagnósticos" rota="diagnosticoatendimento" toolTip="Tipos de Diagnósticos"></sub-menu>
            </div>
            
        </div>
    </mat-nav-list>
